import { Helper } from "../helpers/Helper";

/**
 * StretchedLink Class
 */
export class StretchedLink {

	/**
	 * Constructor
	 *
	 * @param {string} containerEl
	 */
	constructor( containerEl ) {

		this.containerEl = containerEl;
		this.allBlocks = document.querySelectorAll( containerEl );

		if ( this.allBlocks.length === 0 ) {

			return;

		}

		this.init();

	}

	/**
	 * Init
	 */
	init() {

		this.allBlocks.forEach( ( block ) => {

			const anchor = block.querySelector( "a" );
			if ( !anchor ) {

				return;

			}

			if ( this.containerEl === ".b-person-box" ) {

				this.setupPersonBox( block, anchor );

			} else {

				this.setupStretchedLink( anchor );

			}

		} );

	}

	/**
	 * Setup person box functionality
	 * @param {HTMLElement} block
	 * @param {HTMLElement} anchor
	 */
	setupPersonBox( block, anchor ) {

		const href = anchor.getAttribute( "href" );

		if ( !href ) {

			return;

		}

		const target = anchor.getAttribute( "target" );

		block.addEventListener( "click", ( e ) => {

			// Prevent double navigation if clicking directly on anchor
			if ( e.target.tagName === "A" ) {

				return;

			}

			this.navigateToUrl( href, target );

		} );

		Helper.addClassToEl( block, "has-stretched-link" );

	}

	/**
	 * Setup stretched link functionality
	 * @param {HTMLElement} anchor
	 */
	setupStretchedLink( anchor ) {

		const href = anchor.getAttribute( "href" );
		if ( href && href.trim() !== "" ) {

			Helper.addClassToEl( anchor, "is-stretched-link" );

			const container = anchor.closest( this.containerEl );
			if ( container ) {

				Helper.addClassToEl( container, "has-stretched-link" );

			}

		}

	}

	/**
	 * Navigate to URL
	 * @param {string} href
	 * @param {string} target
	 */
	navigateToUrl( href, target ) {

		if ( target === "_blank" ) {

			window.open( href, "_blank" );

		} else {

			window.location.href = href;

		}

	}

}
